import { BaseAction, DataAction } from '../../actions/commons'
import { Hit } from '../../domain/models/rest/SearchResponse'
import {
  BILLING_GUIDE_FETCH_POSTCODES,
  BILLING_GUIDE_FETCH_POSTCODES_SUCCESS,
  BILLING_GUIDE_FETCH_POSTCODES_FAIL,
  BILLING_GUIDE_FETCH_CLINICS,
  BILLING_GUIDE_FETCH_CLINICS_SUCCESS,
  BILLING_GUIDE_FETCH_CLINICS_FAIL,
  BILLING_GUIDE_FETCH_PRICING,
  BILLING_GUIDE_FETCH_PRICING_SUCCESS,
  BILLING_GUIDE_FETCH_PRICING_FAIL,
  BILLING_GUIDE_SET_SELECTED_POSTCODE,
  BILLING_GUIDE_SET_SELECTED_CLINIC,
  BILLING_GUIDE_SET_POSTCODE_INPUT,
  BILLING_GUIDE_CLEAR_POSTCODE_SUGGESTIONS,
  BILLING_GUIDE_SET_SELECTED_PROCEDURE,
} from '../../actions/BillingGuideActions/billingGuideActions'
import { LOGOUT_SUCCESS } from '../../actions/loginAction'
import RequestError from '../../errors/RequestError'
import {
  BillingGuideState,
  PostcodeData,
  PricingData,
} from '../../domain/models/pages/BillingGuideLookupPage/BillingGuideLookupModel'

const initialBillingGuideState: BillingGuideState = {
  postcodes: [],
  clinics: [],
  pricing: null, // null = never searched yet
  loading: {
    postcodes: false,
    clinics: false,
    pricing: false,
  },
  error: {
    postcodes: null,
    clinics: null,
    pricing: null,
  },
  postcodeInput: '',
  selectedPostcode: null,
  selectedClinic: null,
  selectedProcedure: 'All',
}

const billingGuideReducer = (state = initialBillingGuideState, action: BaseAction): BillingGuideState => {
  switch (action.type) {
    // Postcode Actions
    case BILLING_GUIDE_FETCH_POSTCODES: {
      return {
        ...state,
        loading: { ...state.loading, postcodes: true },
        error: { ...state.error, postcodes: null },
      }
    }
    case BILLING_GUIDE_FETCH_POSTCODES_SUCCESS: {
      const a = action as DataAction<Hit<PostcodeData>[]>
      return {
        ...state,
        postcodes: a.data,
        loading: { ...state.loading, postcodes: false },
        error: { ...state.error, postcodes: null },
      }
    }
    case BILLING_GUIDE_FETCH_POSTCODES_FAIL: {
      const a = action as DataAction<RequestError>
      return {
        ...state,
        postcodes: [],
        loading: { ...state.loading, postcodes: false },
        error: { ...state.error, postcodes: a.data.message },
      }
    }

    // Clinic Actions
    case BILLING_GUIDE_FETCH_CLINICS: {
      return {
        ...state,
        loading: { ...state.loading, clinics: true },
        error: { ...state.error, clinics: null },
      }
    }
    case BILLING_GUIDE_FETCH_CLINICS_SUCCESS: {
      const a = action as DataAction<string[]>
      return {
        ...state,
        clinics: a.data,
        loading: { ...state.loading, clinics: false },
        error: { ...state.error, clinics: null },
      }
    }
    case BILLING_GUIDE_FETCH_CLINICS_FAIL: {
      const a = action as DataAction<RequestError>
      return {
        ...state,
        clinics: [],
        loading: { ...state.loading, clinics: false },
        error: { ...state.error, clinics: a.data.message },
      }
    }

    // Pricing Actions
    case BILLING_GUIDE_FETCH_PRICING: {
      return {
        ...state,
        loading: { ...state.loading, pricing: true },
        error: { ...state.error, pricing: null },
      }
    }
    case BILLING_GUIDE_FETCH_PRICING_SUCCESS: {
      const a = action as DataAction<{ pricing: PricingData[] }>
      return {
        ...state,
        pricing: a.data.pricing,
        loading: { ...state.loading, pricing: false },
        error: { ...state.error, pricing: null },
      }
    }
    case BILLING_GUIDE_FETCH_PRICING_FAIL: {
      const a = action as DataAction<RequestError>
      return {
        ...state,
        pricing: [],
        loading: { ...state.loading, pricing: false },
        error: { ...state.error, pricing: a.data.message },
      }
    }

    // Selection Actions
    case BILLING_GUIDE_SET_SELECTED_POSTCODE: {
      const a = action as DataAction<PostcodeData | null>
      return {
        ...state,
        selectedPostcode: a.data,
        // Clear clinics when postcode changes
        clinics: [],
        selectedClinic: null,
      }
    }
    case BILLING_GUIDE_SET_SELECTED_CLINIC: {
      const a = action as DataAction<string | null>
      return {
        ...state,
        selectedClinic: a.data,
      }
    }

    // Postcode Input Actions
    case BILLING_GUIDE_SET_POSTCODE_INPUT: {
      const a = action as DataAction<string>
      return {
        ...state,
        postcodeInput: a.data,
      }
    }
    case BILLING_GUIDE_CLEAR_POSTCODE_SUGGESTIONS: {
      return {
        ...state,
        postcodes: [],
      }
    }

    // Procedure Actions
    case BILLING_GUIDE_SET_SELECTED_PROCEDURE: {
      const a = action as DataAction<string>
      return {
        ...state,
        selectedProcedure: a.data,
      }
    }

    // Reset on logout
    case LOGOUT_SUCCESS:
      return { ...initialBillingGuideState }

    default:
      return state
  }
}

export default billingGuideReducer
